import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BackTop } from 'antd';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import BusinessClassification from "./pages/BusinessClassification";
import TestimonialsPage from "./pages/TetimonialPage";
import Contact from "./pages/Contact";
import TermsNConditions from "./pages/T&cPage";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <div style={{paddingTop:'65px'}}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/business-classification" element={<BusinessClassification />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/termnconditions" element={<TermsNConditions/>}/>
        </Routes>
      </div>
        <BackTop />
        <Footer />
  
    </BrowserRouter>
  );
}

export default App;